import React from "react";
import PropTypes from "prop-types";
import { HeaderNameMenu } from "../../HeaderNameMenu.jsx";

export const Group = ({ name, onLeave }) => {
  return (
    <div className="tw-flex tw-items-center tw-min-w-0">
      <HeaderNameMenu
        name={name}
        onLeave={onLeave}
      />
    </div>
  );
};

Group.propTypes = {
  name: PropTypes.string.isRequired,
  onLeave: PropTypes.func,
};

Group.defaultTypes = {
  canLeave: false,
};
